import React from "react";

import AlertDialog from "../common/AlertDialog";
import { Button } from "../common/customDesignedComponents/button";
import { TAILWIND_GRADIENT_SUBMIT_BUTTON_CLASS } from "../helpers/constants";

/**
 * Offer a dual-portal account the choice between the service-provider portal
 * and staying on the consumer site (e.g. after closing the cross-domain
 * redirect from consumer login → servicer).
 */
const ServiceProviderPortalPrompt = ({
  open,
  onStay,
  onGoToServiceProvider,
  forceChoice = false,
  hasCustomerRole = true,
  emptyProperties = false,
}) => {
  if (!open) {
    return null;
  }

  let detail =
    "Continue to the Service Provider portal to manage clients, or stay on the consumer site.";
  if (!hasCustomerRole) {
    detail =
      "Continue to the Service Provider portal to manage clients, or leave this consumer session.";
  } else if (emptyProperties) {
    detail =
      "You currently have no consumer properties to manage. Continue to the Service Provider portal, or stay here.";
  }

  return (
    <AlertDialog
      openPopup={open}
      type="Info"
      onClose={!forceChoice}
      onCloseFun={onStay}
      isTailwindComponent
      footer={false}
      title="Choose how you want to work"
      mesage={
        <div className="space-y-2 text-sm text-foreground text-left">
          <p>
            This account can use EquityProtect as a service professional or on
            the consumer site.
          </p>
          <p>{detail}</p>
        </div>
      }
      buttons={
        <div className="flex flex-col-reverse gap-2 pt-4 sm:flex-row sm:justify-center">
          <Button variant="outline" onClick={onStay}>
            {hasCustomerRole ? "Stay on consumer site" : "Leave consumer site"}
          </Button>
          <Button
            className={TAILWIND_GRADIENT_SUBMIT_BUTTON_CLASS}
            onClick={onGoToServiceProvider}
          >
            Go to Service Provider portal
          </Button>
        </div>
      }
    />
  );
};

export default ServiceProviderPortalPrompt;
